import { Injectable } from '@angular/core';
import { AuthStoreService, ContentGqlService } from '@motivforce/mx-library-angular';
import { BehaviorSubject } from 'rxjs';
import { filter, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PrivacyPolicyStoreService {
  private readonly _privacyPolicy = new BehaviorSubject<string | null>(null);
  readonly privacyPolicy$ = this._privacyPolicy.asObservable();

  constructor(private contentGql: ContentGqlService, private authStore: AuthStoreService) {}

  get privacyPolicy(): string | null {
    return this._privacyPolicy.getValue();
  }

  initPrivacyPolicy(): void {
    this.getPrivacyPolicyUrl('en-GB');

    this.authStore.userSettings$.pipe(filter(Boolean)).subscribe((userSettings) => {
      this.getPrivacyPolicyUrl(userSettings.language);
    });
  }

  private getPrivacyPolicyUrl(language: string): void {
    const sitePath = new URL(window.location.href);
    const slugPath = `${sitePath.origin}/privacy-url`;

    this.contentGql
      .getContentByUrlPath(slugPath, language, true)
      .pipe(filter(Boolean), take(1))
      .subscribe((content) => {
        const prField = content.fields.find((f: any) => f.name === 'Privacy Url');
        const prUrl = prField!.value.value;
        if (prUrl) {
          // Remove html tags coming from CMS
          this._privacyPolicy.next(prUrl.replace(/(<([^>]+)>)/gi, ''));
        } else this._privacyPolicy.next(null);
      });
  }
}
